import { FunctionComponent } from 'react';
import { NumberFieldType } from '../../types';
import { TextField } from '.';
import { TextFieldTypeEnum } from '../../enums';

const NumberField: FunctionComponent<NumberFieldType> = ({ formikProps, name, label, maxLength, addOn, ...props }) => {
  return (
    <TextField
      formikProps={formikProps}
      name={name}
      label={label}
      type={TextFieldTypeEnum.NUMBER}
      addOn={addOn}
      {...{
        onChange: (event: any) => {
          if (maxLength) {
            event.target.value = event.target.value.substring(0, maxLength);
          }
          formikProps.setFieldValue(name, event.target.value);
        },
      }}
      {...props}
    />
  );
};

export default NumberField;
